import { createApiClient } from '../apiClient';

const apiClient = createApiClient({
  baseURL: '/api/file-service/',
});


const fetchPrivacyPolicy = url => apiClient
  .post('api/file/v1/download-html', url, {
    headers: {
      'Content-Type': 'text/plain;charset=UTF-8',
    },
  })
  .then(response => response.data);

export default {
  fetchPrivacyPolicy,
};
